import { createApi } from "@reduxjs/toolkit/query/react";
import { voyageurEndpoint, voyageurReservationEndpoint } from "routes/api/endpoints"
import { customFetchBaseQuery } from "./auth/queries";

export const voyageurApi = createApi({
    reducerPath: "voyageurApi",
    baseQuery: customFetchBaseQuery(),
    endpoints: (builder) => ({
        addNewVoyageur: builder.mutation({
            query: (voyageurData) => ({
                url: voyageurEndpoint.addNewVoyageur(),
                method: "POST",
                body: voyageurData,
            }),
        }),
        getVoyageurs: builder.query({
            query: (userId) => ({
                url: voyageurEndpoint.addNewVoyageur(),
                method: "GET",
                params: { user: userId },
            }),
        }),
        addNewVoyageurReservation: builder.mutation({
            query: (voyageurReservationData) => ({
                url: voyageurReservationEndpoint.addNewVoyageurReservation(),
                method: "POST",
                body: voyageurReservationData,
            }),
        }),
    }),
});

export const { useAddNewVoyageurReservationMutation, useAddNewVoyageurMutation, useGetVoyageursQuery } = voyageurApi;

export default voyageurApi;
